<template>
    <div id="aqt_content">
      <div class="personal_item" v-for="(personal_item,index) in personalArr1" :key="index">
        <div class="line line1"></div>
        <p class="title title_size1">{{personal_item.about}}</p>
        <p class="title title_size2">{{personal_item.content}}</p>
        <img :src="personal_item.img1" class="img_two"/>
        <div class="own">
          <img :src="personal_item.img2" class="serve2"/>
          <p class="title title_size1">{{personal_item.own}}</p>
          <img :src="personal_item.img3" class="serve2"/>
        </div>
      </div>
<!--      <div class="Aptitudes" v-for="(Aptitudes,index) in AptitudesArr" :key="index + 'b'">-->
<!--        <div class="line line1"></div>-->
<!--        <p class="title title_size1">{{Aptitudes.title}} </p>-->
<!--        <img :src="Aptitudes.img1" class="serve1"/>-->
<!--        <ul class="personal_nav">-->
<!--          <li class="nav1" v-for="( nav,index) in navArr" :key="index + 'a'">-->
<!--            <img :src="nav.img" class="nav_img"/>-->
<!--            <p class="title title_size2">{{nav.title}}</p>-->
<!--          </li>-->
<!--        </ul>-->
<!--        <img v-for="(item,index) in imgarr" :key="index" :src="require(`../../assets/img/${item}`)"  class="serve1"/>-->

<!--        &lt;!&ndash; <img :src="Aptitudes.img2" class="serve1"/>-->
<!--        <img :src="Aptitudes.img4" class="serve1"/>-->

<!--        <img :src="Aptitudes.img5" class="serve1"/>-->
<!--        <img :src="Aptitudes.img3" class="serve1"/>-->
<!--        <img :src="Aptitudes.img6" class="serve1"/> &ndash;&gt;-->
<!--      </div>-->
      <div class="time_line">
        <img src="../../assets/img/personal12.png" class="time_img"/>
        <div class="line_time"></div>
        <p class="title title_size1">时间线</p>
        <div class="time_items">
<!--          <div class="progress_item">-->
<!--            <div class="progress_time">-->
<!--              <p class="item_time">2016年02月</p>-->
<!--            </div>-->
<!--            <img src="../../assets/img/personal13.png" class="progress_img"/>-->
<!--            <p class="progress_content">内蒙古阿启泰科技有限公司正式成立</p>-->
<!--            <div  class="column_line "></div>-->
<!--            <img src="../../assets/img/personal14.png" class="progress_left"/>-->
<!--          </div>-->
<!--          <div class="progress_item">-->
<!--            <div class="progress_time">-->
<!--              <p class="item_time">2016年12月</p>-->
<!--            </div>-->
<!--            <img src="../../assets/img/personal13.png" class="progress_img"/>-->
<!--            <p class="progress_content">游牧文化发布会</p>-->
<!--            <div  class="column_line "></div>-->
<!--          </div>-->
<!--          <div class="progress_item">-->
<!--            <div class="progress_content2">-->
<!--              <p class="progress_content2_title">内蒙古电视台采访报道</p>-->
<!--            </div>-->

<!--            <img src="../../assets/img/personal13.png" class="progress_img"/>-->
<!--            <div class="progress_time2">-->
<!--              <p class="item_time2">2017年01月</p>-->
<!--            </div>-->
<!--            <div  class="column_line "></div>-->
<!--          </div>-->
<!--          <div class="progress_item">-->
<!--            <div class="progress_time">-->
<!--              <p class="item_time">2017年02月</p>-->
<!--            </div>-->
<!--            <img src="../../assets/img/personal13.png" class="progress_img"/>-->
<!--            <p class="progress_content">成立1周年</p>-->
<!--            <div  class="column_line "></div>-->
<!--            <img src="../../assets/img/index2.png" class="progress_right"/>-->
<!--          </div>-->
<!--          <div class="progress_item">-->
<!--            <div class="progress_time">-->
<!--              <p class="item_time">2017年03月</p>-->
<!--            </div>-->
<!--            <img src="../../assets/img/personal13.png" class="progress_img"/>-->
<!--            <p class="progress_content">游牧书屋正式发布</p>-->
<!--            <div  class="column_line "></div>-->
<!--            <img src="../../assets/img/personal15.png" class="progress_left"/>-->
<!--          </div>-->
<!--          <div class="progress_item">-->
<!--            <div class="progress_content2">-->
<!--              <p class="progress_content2_title">参加创新创业获奖</p>-->
<!--            </div>-->

<!--            <img src="../../assets/img/personal13.png" class="progress_img"/>-->
<!--            <div class="progress_time2">-->
<!--              <p class="item_time2">2018年09月</p>-->
<!--            </div>-->
<!--            <div  class="column_line "></div>-->
<!--          </div>-->
<!--          <div class="progress_now">-->
<!--            <div class="progress_time">-->
<!--              <p class="item_time">2019年02月</p>-->
<!--            </div>-->
<!--            <img src="../../assets/img/personal13.png" class="progress_img"/>-->
<!--            <p class="progress_content">成立3周年</p>-->
<!--            <div  class="line_last"></div>-->
<!--            <img src="../../assets/img/personal16.png" class="progress_right"/>-->
<!--            <img src="../../assets/img/8.png" class="img_end"/>-->
<!--            <img src="../../assets/img/personal_last.png" class="personal_last"/>-->
<!--            <p class="end_title">与阿启泰一起逐梦同行</p>-->
<!--          </div>-->

          <div class="progress_item">
            <div class="progress_time">
              <p class="item_time">2016年02月</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <p class="progress_content">内蒙古阿启泰科技有限公司正式成立</p>
            <div  class="column_line "></div>
            <img src="../../assets/img/personal14.png" class="progress_left"/>
          </div>
          <div class="progress_item" style="height: 5rem">
            <div class="progress_time">
              <p class="item_time">2016年12月</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <p class="progress_content">游牧文化发布会</p>
            <div  class="column_line "></div>
          </div>
          <div class="progress_item" style="height: 5rem">
            <div class="progress_content2">
              <p class="progress_content2_title">内蒙古电视台采访报道</p>
            </div>

            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <div class="progress_time2">
              <p class="item_time2">2017年01月</p>
            </div>
            <div  class="column_line "></div>
          </div>
          <div class="progress_item">
            <div class="progress_time">
              <p class="item_time">2017年02月</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <p class="progress_content">成立1周年</p>
            <div  class="column_line "></div>
            <img src="../../assets/img/index2.png" class="progress_right"/>
          </div>
          <div class="progress_item" style="height: 5rem">
            <div class="progress_time">
              <p class="item_time">2017年03月</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <p class="progress_content">游牧书屋正式发布</p>
            <div  class="column_line "></div>
          </div>
          <div class="progress_item">
            <div class="progress_content2">
              <p class="progress_content2_title">阿启泰智慧图书馆发布</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <div class="progress_time2">
              <p class="item_time2">2019年05月</p>
            </div>
            <div  class="column_line "></div>
            <img src="../../assets/img/personal_time1.png" class="progress_left"/>

          </div>
          <div class="progress_item">
            <div class="progress_time">
              <p class="item_time">2020年03月</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <p class="progress_content">《阿启泰书籍文献》APP上线</p>
            <div  class="column_line "></div>
            <img src="../../assets/img/personal_time2.png" class="progress_right" style="top:20%"/>
          </div>
          <div class="progress_item" style="height: 13rem">
            <div class="progress_content2">
              <p class="progress_content2_title">阿启泰文化艺术大数据建设</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <div class="progress_time2">
              <p class="item_time2">2020年05月</p>
            </div>
            <div  class="column_line "></div>
            <img src="../../assets/img/personal_time3.png" class="progress_left" style="width: 28%;top: 23%" />

          </div>
          <div class="progress_item" style="height: 5rem">
            <div class="progress_time">
              <p class="item_time">2022年12月</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <p class="progress_content">第一次获得高新技术企业评定</p>
            <div  class="column_line "></div>
          </div>
          <div class="progress_item">
            <div class="progress_content2">
              <p class="progress_content2_title">《阿启泰文化艺术》APP发布</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <div class="progress_time2">
              <p class="item_time2">2024年01月</p>
            </div>
            <div  class="column_line "></div>
            <img src="../../assets/img/personal_time4.png" class="progress_left" style="top: 28%" />

          </div>
          <div class="progress_item" style="height: 5rem">
            <div class="progress_time">
              <p class="item_time">2024年06月</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <p class="progress_content">纳税信用等级AAA</p>
            <div  class="column_line "></div>
          </div>
          <div class="progress_item" style="height: 5rem">
            <div class="progress_content2">
              <p class="progress_content2_title">获得广播电视节目制作经营许可证</p>
            </div>

            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <div class="progress_time2">
              <p class="item_time2">2024年07月</p>
            </div>
            <div  class="column_line "></div>
          </div>
          <div class="progress_item" style="height: 5rem">
            <div class="progress_time">
              <p class="item_time">2024年07月</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <p class="progress_content">获得增值电信业务经营许可证</p>
            <div  class="column_line "></div>
          </div>
          <div class="progress_item" style="height: 5rem">
            <div class="progress_content2">
              <p class="progress_content2_title">获得出版物经营许可证</p>
            </div>

            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <div class="progress_time2">
              <p class="item_time2">2024年09月</p>
            </div>
            <div  class="column_line "></div>
          </div>
          <div class="progress_item" style="height: 5rem">
            <div class="progress_time">
              <p class="item_time">2025年01月</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <p class="progress_content">非遗丛书制作编写</p>
            <div  class="column_line "></div>
          </div>
          <div class="progress_now">
            <div class="progress_content2">
              <p class="progress_content2_title">第二次获得高新技术企业评定</p>
            </div>
            <img src="../../assets/img/personal13.png" class="progress_img"/>
            <div class="progress_time2">
              <p class="item_time2">2025年12月</p>
            </div>
<!--            <div  class="line_last"></div>-->
            <img src="../../assets/img/8.png" class="img_end"/>
            <img src="../../assets/img/personal_last.png" class="personal_last"/>
            <p class="end_title">与阿启泰一起逐梦同行</p>
          </div>
        </div>

      </div>
    </div>
</template>

<script>
    export default {
      data(){
        return {
          personalArr1:[
            {
              about:'关于阿启泰',
              content:'关于阿启泰：阿启泰科技自2016年创立以来，坚守 “感恩、效率、进步、责任” 的核心价值观，以技术创新为核心引擎，深耕智慧图书馆与文化艺术资源数字化建设领域。公司现已拥有25项软件著作权，获评诚信达标企业及多项企业等级认证；先后于2022年、2025年连续通过高新技术企业认定，并在2022年荣获内蒙古自治区工业和信息化厅认定的内蒙古自治区首版次软件产品认定等多项权威资质与荣誉，致力于为客户提供安全、高效、值得信赖的全场景技术服务与数字化解决方案。',
              img1:require('../../assets/img/personal1.png'),
              img2:require('../../assets/img/serve2.png'),
              img3:require('../../assets/img/serve3.png'),
              own:'创造科技的无限可能性'

            }
          ],
          AptitudesArr:[
            {
              title:'阿启泰资质证明',
              img1:require('../../assets/img/personal4.png'),
              img2:require('../../assets/img/personal9.png'),

              img4:require('../../assets/img/personal11.png'),
              img3:require('../../assets/img/personal10.png'),
              img5:require('../../assets/img/personal18.jpg'),
              img6:require('../../assets/img/personal19.jpg'),

            }
          ],
          navArr:[
            {
              img:require('../../assets/img/personal7.png'),
              title:'阿启泰游牧文化系统软件'
            },
            {
              img: require('../../assets/img/personal5.png'),
              title: '掌上蒙汉双语图书馆系统'
            },
            {
              img:require('../../assets/img/personal8.png')  ,
              title:'民俗数据库系统'
            } ,
            {
              img:require('../../assets/img/personal5.png')  ,
              title:'智慧牧场软件开发运行维护监控软件'
            } ,
            {
              img:require('../../assets/img/personal7.png')  ,
              title:'民歌民乐大数据平台系统'
            } ,
            {
              img:require('../../assets/img/personal8.png'),
              title:'待更新'
            },


          ],


        }
      }
    }
</script>

<style scoped lang="less">
  #aqt_content{
    padding-top:4rem;
    .line{
      margin: 0 auto;
      width: 10%;
      height: 0.1rem;
      text-align: center;
      margin-top: 3rem;
      margin-bottom: 2rem;
    }
    .line1{
      background-color:#F5A623;
    }
    .title{
      margin-left: 0.5rem;
      margin-right: 0.5rem;
      text-align: center;
      letter-spacing: 0.1rem;
    }
    .title_size1{
      font-size: 1.1rem;
      color: #F4FAFF;
    }
    .title_size2{
      font-size: 0.8rem;
      color: #D3DFFF;
      line-height: 1.2rem;
      marign-top: 1rem;
      margin-top: 1rem;
      text-align:center;
    }
    .personal_item{
      .img_two{
        width:74%;
        margin-top:1rem;
        margin-left:14%;
        margin-bottom:1rem;
      }
      .own{
        width:100%;
        height:100%;
        margin-top:2rem;
        display:flex;
        flex-direction:row;
        justify-content: space-around;
        .serve2{
          width:2rem;
        }


      }

    }
    .Aptitudes{
      .serve1{
        width: 60%;
        margin-left: 20%;
        margin-top: 2rem;
      }
      .personal_nav{
        width:100%;
        height: 10rem;
        margin-top: 2rem;
        margin-bottom:8rem;
        .nav1{
          width:100%;
          height:2.5rem;
          margin-top:0.5rem;
          display:flex;
          flex-direction:row;
          .nav_img {
            margin-left: 2rem;
            height: 1.2rem;
            margin-top: 1.1rem;
          }

        }
      }
    }
    .time_line{
      .line_time{
        margin:0 auto;
        width:7%;
        height:0.1rem;
        text-align:center;
        margin-top:1rem;
        margin-bottom:0.5rem;
        background-color:#F5A623;
      }
      position:relative;
      .time_img{
        display:block;
        width: 3.5rem;
        margin:0 auto;
        margin-top: 10%;

      }
      .time_items{
        width:100%;
        height:auto;
        position:relative;
        margin-top:3rem;
        .progress_item{
          width:100%;
          height:12rem;
          display:flex;
          flex-direction:row;
          position:relative;
          .progress_img{
            width:1.2rem;
            height:1.2rem;
            position:absolute;
            left:47.4%;
          }
          .progress_time{
            display:inline-block;
            width:39.5%;
            height:2rem;
            position:absolute;
            left:5%;
            .item_time{
              width:60%;
              height:1.5rem;
              position:absolute;
              right:0;
              text-align:center;
              line-height:1.5rem;
              color:#6A98F1;
              border: 1px solid #6A98F1;
              border-radius: 6.8rem;
            }
          }
          .progress_content{
            display:inline-block;
            width:39.5%;
            height:2rem;
            position:absolute;
            right:5%;
            color:#fff;
            font-size:0.8rem;
            letter-spacing: 0.1rem;
          }
          .column_line{
            position:absolute;
            top:11%;
            left: 49.4%;
            border-left: 1px dashed #F59D3E;
            height:11rem;
            line-height:1px;
            z-index:88;
          }


          .progress_content2{
            display:inline-block;
            width:39.5%;
            height:2rem;
            position:absolute;
            left:5%;
            color:#fff;
            font-size:0.8rem;
            letter-spacing: 0.1rem;
            .progress_content2_title{
              width:80%;
              text-align:center;
            }
          }
          .progress_time2{
            display:inline-block;
            width:39.5%;
            height:2rem;
            position:absolute;
            right:5%;
            color:#fff;
            font-size:0.8rem;
            letter-spacing: 0.1rem;
            .item_time2{
              width:60%;
              height:1.5rem;
              position:absolute;
              left:0;
              color:#6A98F1;
              text-align:center;
              line-height:1.5rem;
              border: 1px solid #6A98F1;
              border-radius: 6.8rem;
            }
          }
          .progress_right{
            width: 40%;
            position: absolute;
            right: 4%;
            top: 6%;
            z-index:89;
          }
          .progress_left{
            width: 40%;
            position: absolute;
            left: 4%;
            top: 12%;
          }

          .img_end{
            width:1.2rem;
            height:1.2rem;
            position:absolute;
            left:47.4%;
            top: 71%;
            /*z-index: 99;*/
          }
        }
        .progress_now{
          width:100%;
          height:12rem;
          display:flex;
          flex-direction:row;
          position:relative;
          .progress_img{
            width:1.2rem;
            height:1.2rem;
            position:absolute;
            left:47.4%;
          }
          .progress_time{
            display:inline-block;
            width:39.5%;
            height:2rem;
            position:absolute;
            left:5%;
            .item_time{
              width:60%;
              height:1.5rem;
              position:absolute;
              right:0;
              text-align:center;
              line-height:1.5rem;
              color:#6A98F1;
              border: 1px solid #6A98F1;
              border-radius: 6.8rem;
            }
          }
          .progress_content{
            display:inline-block;
            width:39.5%;
            height:2rem;
            position:absolute;
            right:5%;
            color:#fff;
            font-size:0.8rem;
            letter-spacing: 0.1rem;
          }
          .line_last{
            position:absolute;
            top:8%;
            left: 49.4%;
            border-left: 1px dashed #F59D3E;
            height:11rem;
            line-height:1px;
            z-index:88;
          }


          .progress_content2{
            display:inline-block;
            width:39.5%;
            height:2rem;
            position:absolute;
            left:5%;
            color:#fff;
            font-size:0.8rem;
            letter-spacing: 0.1rem;
            .progress_content2_title{
              width:80%;
              text-align:center;
            }
          }
          .progress_time2{
            display:inline-block;
            width:39.5%;
            height:2rem;
            position:absolute;
            right:5%;
            color:#fff;
            font-size:0.8rem;
            letter-spacing: 0.1rem;
            .item_time2{
              width:60%;
              height:1.5rem;
              position:absolute;
              left:0;
              color:#6A98F1;
              text-align:center;
              line-height:1.5rem;
              border: 1px solid #6A98F1;
              border-radius: 6.8rem;
            }
          }
          .progress_right{
            width: 40%;
            position: absolute;
            right: 4%;
            top: 6%;
            z-index:89;
          }


          .img_end{
            width:1.2rem;
            height:1.2rem;
            position:absolute;
            left:47.4%;
            top: 50%;
            /*z-index: 99;*/
          }
          .personal_last{
            width:100%;
          }
          .end_title{
            position:absolute;
            top: 70%;
            left: 30%;
            color:#D3DFFF;
            font-size:1.1rem;
          }
        }

      }
    }
  }
</style>

